import { EventAvailabilityDetails, EventDetails } from "features/types";

export const convertEventAvailabilityDetails = (
  eventAvailablity: EventAvailabilityDetails
) => {
  return {
    ...eventAvailablity,
    // Dummy values for now
    status: "NORMAL",
    id: eventAvailablity.eventId,
    name: eventAvailablity.eventName,
    type: eventAvailablity.eventType,
    code: "",
    allowGroupCodeReleases: false,
    showBarcodes: false,
  } as EventDetails;
};
